<div class="ui-g">
    <div class="ui-g-12" *ngIf="totaling && totaling.length > 0">
        <p-accordion [activeIndex]="0">
            <p-accordionTab header="Totaling Definition">
                <!--<p-chips [(ngModel)]="filterAccounts" id="myTextField">
                    <ng-template let-item pTemplate="item" id="myTextField">
                        {{item.name}}  <i class="pi pi-user ml-2"></i>
                    </ng-template>
                </p-chips>-->
                <div class="my-chip-box">
                    <div class="my-chip" *ngFor="let col of totaling">
                        <div class="my-chip-content" (click)="this.openExistingChip(col)" pTooltip="{{ col.Descriptions }}" tooltipPosition="top" tooltipStyleClass="custom-tooltip-content" [escape]="false">
                            <span >{{ col.Names }}</span>
                        </div>
                        <div class="my-chip-close" (click)="this.removeAccounts(col.Ids)">
                            <svg class="my-chip-svg" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z">
                                </path>
                            </svg>
        
                        </div>
                    </div>
                </div>
        
            </p-accordionTab>
        </p-accordion>
       <!--<p-chips
            [(ngModel)]="totaling"
            allowDuplicate="false"
            (onRemove)="onRemove()"
            (onChipClick)="openExistingChip($event)"
        >
            <ng-template let-item pTemplate="item">
                <div
                    pTooltip="{{ item.Descriptions }}"
                    tooltipPosition="top"
                    [escape]="false"
                >
                    <span>{{ item.Names }}</span>
                </div>
            </ng-template>
        </p-chips>--> 
        <!--<p-accordion [activeIndex]="0">
            <p-accordionTab >
                <div class="my-chip-box">
                    <div class="my-chip" *ngFor="let col of totaling">
                        <div class="my-chip-content" pTooltip="{{ col.Descriptions }}" tooltipPosition="top" [escape]="false">
                            <span>{{ col.Names }}</span>
                        </div>
                        <div class="my-chip-close" (click)="onRemove(col.id)">
                            <svg class="my-chip-svg" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z">
                                </path>
                            </svg>
        
                        </div>
                    </div>
                </div>
        
            </p-accordionTab>
        </p-accordion>-->
       
    </div>
    <div class="ui-g-12">
        <button
            type="button"
            (click)="openModalForSingles()"
            pButton
            icon="ui-icon-touch-app"
            label="Pick Accounts"
            [disabled]="isDisabled"
        ></button>
        <button
            type="button"
            (click)="openModalForRanges()"
            pButton
            icon="ui-icon-playlist-add-check"
            label="Pick Account Range"
            [disabled]="isDisabled"
        ></button>
    </div>

    <p-dialog
        header="Pick Accounts"
        [(visible)]="displayModalForSingles"
       
        appendTo="body"
        [style]="{ width: '100%',height: '100%', align: 'center' }"
        
        (onHide)="closeModal()"
    >
        <div class="ui-g">
            <div class="ui-g-6">
                <modal-show-line-accounts
                    [lineId]="lineId"
                    filter="included"
                    buttonText="Line Accounts"
                    buttonIcon="ui-icon-remove-red-eye"
                ></modal-show-line-accounts>
                <modal-show-report-accounts
                    [reportId]="reportId"
                    buttonIcon="ui-icon-remove-red-eye"
                    buttonText="Report Accounts"
                    filter="included"
                ></modal-show-report-accounts>
                <modal-show-report-accounts
                    [reportId]="reportId"
                    buttonIcon="ui-icon-list"
                    buttonText="All Accounts"
                    filter="all"
                ></modal-show-report-accounts>
                <button
                    pButton
                    class="pull-right p-mt-2"
                    icon="ui-icon-chevron-right"
                    (click)="pick()"
                    [disabled]="pickButtonDisabled"
                ></button>
                <br />
                <br />
                <tree-table
                    [inputTreeNodes]="accountsForTable"
                    [treeColumns]="tableColumns"
                    [loadingTreeNodes]="loading"
                    selectionMode="multiple"
                    [(selected)]="this.selectedSingleAccountsLeft"
                    (onSearchEnter)="this.enterKeyPressedInLeftTable($event)"
                ></tree-table>
            </div>
            <div class="ui-g-6" style="text-align: right;">
                <button
                    pButton
                    class="pull-left p-mt-2"
                    icon="ui-icon-chevron-left"
                    (click)="unpick()"
                    [disabled]="unpickButtonDisabled"
                ></button>
                <!--<button
                    *ngIf="selectedAccounts.length > 0"
                    type="button"
                    label="Save"
                    pButton
                    icon="ui-icon-save"
                    (click)="saveSinglesAccountTotaling()"
                    style="margin-right: 0.5em"
                ></button>-->
                <button
                    type="button"
                    label="Close"
                    pButton
                    icon="ui-icon-cancel"
                    (click)="closeModal()"
                ></button>
                <br />
                <br />
                <tree-table
                    [inputTreeNodes]="selectedAccounts"
                    [treeColumns]="tableColumns"
                    [loadingTreeNodes]="loading"
                    selectionMode="multiple"
                    [(selected)]="this.selectedSingleAccountsRight"
                ></tree-table>
            </div>
        </div>
    </p-dialog>

    <p-dialog
        [header]="this.rangesModalTitle"
        [(visible)]="displayModalForRanges"
        [style]="{ width: '50%', align: 'center' }"
        appendTo="body"
        (onHide)="closeModal()"
    >
        <div class="ui-g">
            <div class="ui-g-12">
                <tree-table
                    *ngIf="rangesModalStep == 1"
                    [inputTreeNodes]="accountsForTable"
                    [treeColumns]="tableColumns"
                    [loadingTreeNodes]="loading"
                    selectionMode="single"
                    [(selected)]="this.selectedSingleAccountFrom"
                    disableHierarchyButton=true
                ></tree-table>
                <tree-table
                    *ngIf="rangesModalStep == 2"
                    [inputTreeNodes]="accountsForTableForAccountTo"
                    [treeColumns]="tableColumns"
                    [loadingTreeNodes]="loading"
                    selectionMode="single"
                    [(selected)]="this.selectedSingleAccountTo"
                    disableHierarchyButton=true
                ></tree-table>
            </div>
        </div>

        <div class="ui-g">
            <div class="ui-g-12">
                <button
                    *ngIf="selectedSingleAccountFrom && rangesModalStep == 1"
                    type="button"
                    label="Set From"
                    pButton
                    icon="ui-icon-touch-app"
                    (click)="selectSingleAccountFrom()"
                    style="margin-right: 0.5em"
                ></button>
                <button
                    *ngIf="selectedSingleAccountFrom && rangesModalStep == 2"
                    type="button"
                    label="Reset From"
                    pButton
                    icon="ui-icon-chevron-left"
                    (click)="rangesModalStep = 1"
                    style="margin-right: 0.5em"
                ></button>
                <button
                    [disabled]="!(selectedSingleAccountTo && rangesModalStep == 2)"
                    type="button"
                    label="Set To"
                    pButton
                    icon="ui-icon-touch-app"
                    (click)="saveRangeAccountTotaling()"
                    style="margin-right: 0.5em"
                ></button>
                <button
                    type="button"
                    label="Cancel"
                    pButton
                    icon="ui-icon-cancel"
                    (click)="closeModal()"
                ></button>
            </div>
        </div>
    </p-dialog>
</div>
